import { render } from "./App.vue?vue&type=template&id=f6976bc4&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f6976bc4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f6976bc4"

export default script